export const TOP_TOOL_PROPS = {
    selected: null
};